import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import { Button } from "components/Button";
import MyButton from "components/MyButton";
import React, { useState } from "react";
import MournersList from "../NewYahrzeit/MournersList";

const DrawerMournerList = ({
  handleDelete,
  mourners,
  onSubmit,
  isEdit,
  yahrziet,
  openAddMournerModal,
  ...props
}) => {
  const [disable, setDisable] = useState(true);
  const response = { ...props };
  return (
    <div className="">
      <MournersList
        drawerDisplay={true}
        {...props}
        handleDelete={handleDelete}
        handleClick={() => {}}
        mourners={mourners}
        isEdit={isEdit}
        setDisable={setDisable}
        onEditClick={(mourner) => {
          openAddMournerModal(mourners, "edit", mourner)
        }}
      />
        <div
          className="add-new-payment-info mt-4 justify-content-center"
          onClick={() => {
            openAddMournerModal(mourners);
          }}
        >
          <span className="add-icon">
            <AddIcon width={16} height={16} />
          </span>
          <span className="add">Add New Mourner</span>
        </div>
      <hr />
      <div className="mt-4 btn-flex">
          <Button 
            onClick={onSubmit}
            disabled={response?.values?.doesnt_have_mourner ? false : disable}
            style={{ marginBottom: 20 }}
          >
            <span>Save</span>
          </Button>
      </div>
    </div>
  );
};

export default DrawerMournerList;
